/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Actions_DetailInputs */

const en_tables_actions_detail = /** @type {(inputs: Tables_Actions_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const de_tables_actions_detail = /** @type {(inputs: Tables_Actions_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Tables_Actions_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_actions_detail = /** @type {((inputs?: Tables_Actions_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Actions_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_actions_detail(inputs)
	return de_tables_actions_detail(inputs)
});